var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Données GA pour une liste d'URLs")]),_c('v-card',{staticClass:"mb-6 pa-2"},[_c('v-row',{staticClass:"ma-3"},[_c('v-col',{attrs:{"cols":"12"}},[_c('filters')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }